module.exports = __webpack_public_path__ + "static/macOS-ae43451d1d6110e3546061b91a332872.png";